import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import ColorlibConnector from './ColorlibConnector';
import ColorlibStepIcon from './ColorlibStepIcon';

const steps = ['Data Pesanan', 'Data Peniatan', 'Pilihan Paket', 'Kelengkapan', 'Ringkasan'];

const CustomStepper = ({ activeStep }: { activeStep: number }) => (
<div
  style={{
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    scrollSnapType: 'x mandatory',
    scrollbarWidth: 'none', // Untuk Firefox
    msOverflowStyle: 'none', // Untuk IE & Edge
    WebkitOverflowScrolling: 'touch', // Smooth scroll untuk iOS
  }}
>
  {/* Sembunyikan Scrollbar di Chrome, Safari, Edge */}
  <style>
    {`
      div::-webkit-scrollbar {
        display: none;
      }
    `}
  </style>

  <Stepper
    alternativeLabel
    activeStep={activeStep}
    connector={<ColorlibConnector />}
    style={{
      display: 'inline-flex',
      scrollSnapAlign: 'start',
    }}
  >
    {steps.map((label) => (
      <Step key={label} style={{ flex: '0 0 auto', scrollSnapAlign: 'start' }}>
        <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
      </Step>
    ))}
  </Stepper>
</div>
);

export default CustomStepper;